import { type Context, useContext } from "react";
import type { Nullable } from "@/types";
import ContextNotInitializedException from "../exceptions/ContextNotInitializedException.ts";

export default function useInitializedContext<T>(context: Context<Nullable<T>>, provider: string) {
    const ctx = useContext(context);
    if (!ctx) throw new ContextNotInitializedException(provider);

    return ctx;
}
